/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUser } from './HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUser';
import {
    HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserFromJSON,
    HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserFromJSONTyped,
    HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserToJSON,
    HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserToJSONTyped,
} from './HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUser';
import type { HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetails } from './HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetails';
import {
    HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetailsFromJSON,
    HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetailsFromJSONTyped,
    HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetailsToJSON,
    HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetailsToJSONTyped,
} from './HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetails';
import type { HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInner } from './HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInner';
import {
    HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInnerFromJSON,
    HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInnerFromJSONTyped,
    HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInnerToJSON,
    HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInnerToJSONTyped,
} from './HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInner';

/**
 * 
 * @export
 * @interface HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist
 */
export interface HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist {
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist
     */
    lead_id?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist
     */
    status?: HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusEnum;
    /**
     * 
     * @type {HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetails}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist
     */
    details?: HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetails;
    /**
     * 
     * @type {number}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist
     */
    rank?: number;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist
     */
    created_at?: string;
    /**
     * 
     * @type {HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUser}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist
     */
    status_set_by_user?: HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUser;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist
     */
    receipt_id?: string;
    /**
     * 
     * @type {Array<HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInner>}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist
     */
    updates?: Array<HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInner>;
}


/**
 * @export
 */
export const HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusEnum = {
    Waitlisted: 'Waitlisted',
    Cleared: 'Cleared',
    Cancelled: 'Cancelled'
} as const;
export type HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusEnum = typeof HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusEnum[keyof typeof HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusEnum];


/**
 * Check if a given object implements the HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist interface.
 */
export function instanceOfHchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist(value: object): value is HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist {
    return true;
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistFromJSON(json: any): HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist {
    return HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistFromJSONTyped(json, false);
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'lead_id': json['lead_id'] == null ? undefined : json['lead_id'],
        'status': json['status'] == null ? undefined : json['status'],
        'details': json['details'] == null ? undefined : HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetailsFromJSON(json['details']),
        'rank': json['rank'] == null ? undefined : json['rank'],
        'created_at': json['created_at'] == null ? undefined : json['created_at'],
        'status_set_by_user': json['status_set_by_user'] == null ? undefined : HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserFromJSON(json['status_set_by_user']),
        'receipt_id': json['receipt_id'] == null ? undefined : json['receipt_id'],
        'updates': json['updates'] == null ? undefined : ((json['updates'] as Array<any>).map(HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInnerFromJSON)),
    };
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistToJSON(json: any): HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist {
    return HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistToJSONTyped(json, false);
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistToJSONTyped(value?: HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlist | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lead_id': value['lead_id'],
        'status': value['status'],
        'details': HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistDetailsToJSON(value['details']),
        'rank': value['rank'],
        'created_at': value['created_at'],
        'status_set_by_user': HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserToJSON(value['status_set_by_user']),
        'receipt_id': value['receipt_id'],
        'updates': value['updates'] == null ? undefined : ((value['updates'] as Array<any>).map(HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistUpdatesInnerToJSON)),
    };
}

